// extracted by mini-css-extract-plugin
export default {"button-container":"YqS35J","buttonContainer":"YqS35J","text":"O8Y_AG"};